import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=67a25b2a&scoped=true"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=67a25b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a25b2a",
  null
  
)

export default component.exports